import React from 'react';
import { shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useSignInPage } from '@magento/peregrine/lib/talons/SignInPage/useSignInPage';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { StoreTitle } from '@magento/venia-ui/lib/components/Head';
import defaultClasses from './signInPage.module.css';
import SignIn from '../SignIn';
import heroImage from '../../assets/image.jpg';
import { Button } from '..';

var SignInPage = function SignInPage(props) {
  var classes = useStyle(defaultClasses, props.classes);

  var _useSignInPage = useSignInPage(props),
      signInProps = _useSignInPage.signInProps;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var history = useHistory();
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("img", {
    src: heroImage,
    alt: "Sign in hero image",
    className: "w-full"
  }), React.createElement(StoreTitle, null, formatMessage({
    id: 'signInPage.title',
    defaultMessage: 'Sign In'
  })), React.createElement("div", {
    className: "grid grid-cols-12 container mt-10 md_mt-16"
  }, React.createElement(SignIn, signInProps), React.createElement("div", {
    className: "col-start-1 lg_col-start-5 mt-6 lg_mt-0 mb-6 md_mb-0 md_mb-0 lg_col-end-9 col-span-12 lg_col-span-4 bg-snowbound mt-12"
  }, React.createElement("div", {
    className: "border-b lg_border-b-0 border-r-0 lg_border-r border-solid border-gray pl-20 pr-16 text-center pt-20 pb-24"
  }, React.createElement("h6", {
    className: "mb-3 "
  }, "Existing Account?"), React.createElement("p", {
    className: "mb-5 text-bronze leading-171"
  }, "If your company is established with Hubbardton Forge directly, please click below to gain immediate access to your account dashboard."), React.createElement(Button, {
    onClick: function onClick() {
      return history.push('/register');
    },
    priority: "normal",
    "aria-label": "Active user"
  }, "ACTIVE USER"))), React.createElement("div", {
    className: "col-span-12 lg_col-span-4 bg-snowbound  text-center "
  }, React.createElement("div", {
    className: "pt-20 pb-24 pl-16 pr-20 flex items-center justify-between flex-col h-full"
  }, React.createElement("div", null, React.createElement("h6", {
    className: "mb-3 text-black"
  }, "Create New Website Profile"), React.createElement("p", {
    className: "text-center text-bronze mb-3 leading-171"
  }, "Interested in gaining access to exclusive tools & resources? Register Today!")), React.createElement(Button, {
    priority: "normal",
    onClick: function onClick() {
      return history.push('/register');
    },
    "aria-label": "Register"
  }, "GET STARTED")))));
};

SignInPage.defaultProps = {
  createAccountPageUrl: '/register',
  forgotPasswordPageUrl: '/forgot-password',
  signedInRedirectUrl: '/'
};
SignInPage.propTypes = {
  classes: shape({
    root: string,
    header: string,
    contentContainer: string
  }),
  createAccountPageUrl: string,
  forgotPasswordPageUrl: string,
  signedInRedirectUrl: string
};
export default SignInPage;